import { DataCard } from "components/DataCardComponent/styles"

export interface IFinalizedContainerProps {
  totalNumber: string
  withTreatmentNumber: string
  withoutTreatmentNumber: string
}
export const FinalizedContainer = ({ totalNumber, withTreatmentNumber, withoutTreatmentNumber }: IFinalizedContainerProps) => {
  return (
    <DataCard className='w-full h-[120px] flex items-center'>
      <div className="flex flex-col shrink-0">
        <span className='text-darkGray text-[28px] font-semibold'>{totalNumber || 0}</span>
        <span className='text-base'>
          Status
        </span>
        <span className='text-base'>
          Finalizadas
        </span>
      </div>
      <div className='h-full w-px bg-borderLine shrink-0 mx-4' aria-hidden />
      <div className="min-w-0">
        <div className='flex flex-col h-full justify-center text-darkGray'>
          <div className='leading-tight'>
            <span className='text-sm font-medium whitespace-nowrap'>Com tratativa</span>
            <div className='text-base font-bold'>{withTreatmentNumber || 0}</div>
          </div>
          <div className='h-px bg-borderLine my-1' aria-hidden />
          <div className='leading-tight'>
            <span className='text-sm font-medium whitespace-nowrap'>Sem tratativa</span>
            <div className='text-base font-bold'>{withoutTreatmentNumber || 0}</div>
          </div>
        </div>
      </div>
    </DataCard>
  )
}

